import { useContext, useCallback } from 'react';
import { LanguageContext } from './LanguageContext';
import { translate } from './index';

/**
 * Custom hook for translations
 * @returns {object} Translation function and language utilities
 */
export const useTranslation = () => {
  const { language, setLanguage, languages } = useContext(LanguageContext);

  /**
   * Translate a key to current language
   * @param {string} key - Translation key (e.g., 'nav.home')
   * @param {object} params - Optional parameters for string interpolation
   * @returns {string} Translated text
   */
  const t = useCallback((key, params = {}) => {
    let text = translate(language, key);
    if (params && typeof text === 'string') {
      Object.keys(params).forEach(param => {
        const regex = new RegExp(`{{${param}}}`, 'g');
        text = text.replace(regex, params[param]);
      });
    }
    
    return text;
  }, [language]);

  return {
    t,
    language,
    setLanguage,
    languages
  };
};

export default useTranslation;

